/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorActionLogDto } from '../../models/vendor-action-log-dto';

export interface VendorActionLogControllerFindById$Params {
  id: string;
}

export function vendorActionLogControllerFindById(http: HttpClient, rootUrl: string, params: VendorActionLogControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorActionLogDto>> {
  const rb = new RequestBuilder(rootUrl, vendorActionLogControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorActionLogDto>;
    })
  );
}

vendorActionLogControllerFindById.PATH = '/api/vendorActionLLog/{id}';
